import { Field } from "@/core/types/types";
import { useTranslations as t } from "@/core/hooks/useTranslations/useTranslations";

function useInvalidForm(field: Field) {
  const isInvalid =
    field.properties !== null && field.properties.isInvalidForm === "true";
  let invalidMessage;
  if (isInvalid) {
    invalidMessage = t(`validate.${field.key}.invalid.message`);
  }
  const fieldKey = field.key;

  return { isInvalid, invalidMessage, fieldKey };
}

export { useInvalidForm };
